import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSave } from '@fortawesome/free-solid-svg-icons';

const ModalPermissoes = ({ 
    show, 
    fecharModal, 
    registroId, 
    grupoId, 
    getCookie, 
    showToast 
}) => {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (show && registroId) {
            buscarUsuariosComPermissoes();
        }
    }, [show, registroId]);



    const buscarUsuariosComPermissoes = async () => {
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscarTodos?idregistro=${registroId}`, {
                method: 'GET',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const result = await response.json();
            
            if (result.status === "ok") {
                // Verifica se a estrutura de dados está correta
                console.log('Dados recebidos:', result);
                
                // Mapeia os dados para o formato esperado pelo componente
                const usuariosFormatados = result.lista.map(usuario => ({
                    id: usuario.id || usuario._id, // Adapta para ambos os casos (id ou _id)
                    nome: usuario.nome,
                    checked: usuario.checked || "" // Garante que sempre tenha o campo checked
                }));
                
                setUsuarios(usuariosFormatados);
            } else {
                showToast(result.mensagem || 'Erro ao buscar usuários', 'error');
            }
        } catch (error) {
            //console.error('Erro ao buscar usuários:', error);
            showToast('Erro ao buscar usuários. Verifique sua conexão ou permissões.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const togglePermissao = (usuarioId) => {
        setUsuarios(usuarios.map(usuario => 
            usuario.id === usuarioId 
                ? { ...usuario, checked: usuario.checked === "checked" ? "" : "checked" } 
                : usuario
        ));
    };

    const salvarPermissoes = async () => {
        try {
            const usuariosSelecionados = usuarios
                .filter(usuario => usuario.checked === "checked")
                .map(usuario => usuario.id);

            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/atualizarPermissoes`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: registroId,
                    id_grupo: grupoId,
                    usuarios: usuariosSelecionados
                }),
            });

            const result = await response.json();
            if (result.status === "ok") {
                showToast('Permissões atualizadas com sucesso!', 'success');
                fecharModal();
            } else {
                showToast(result.mensagem || 'Erro ao atualizar permissões', 'error');
            }
        } catch (error) {
            console.error('Erro ao salvar permissões:', error);
            showToast('Erro ao salvar permissões', 'error');
        }
    };

    // Filtrar usuários baseado no termo de busca
    const filteredUsuarios = usuarios.filter(usuario =>
        usuario.nome.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            {show && (
                <>
                    <div className="modal-overlay" onClick={fecharModal}></div>
                    <div className="modal-permissoes">
                        <div className="modal-header">
                            <h3>Gerenciar Permissões</h3>
                            <button onClick={fecharModal} className="btn-close-modal">
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Buscar usuários..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="search-input-permissao"
                            />
                        </div>
                        <div className="usuario-modal-body">
                            {loading ? (
                                <div className="loading-container">
                                    <p>Carregando usuários...</p>
                                    {/* Você pode adicionar um spinner aqui */}
                                </div>
                            ) : (
                                <>
                                    {/* <div className="search-container">
                                        <input
                                            type="text"
                                            placeholder="Buscar usuários..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="search-input-permissao"
                                        />
                                    </div> */}
                                    <div className="usuarios-lista">
                                        {filteredUsuarios.length > 0 ? (
                                            filteredUsuarios.map(usuario => (
                                                <div key={usuario.id} className="usuario-item">
                                                    <label className="checkbox-container">
                                                        <input
                                                            type="checkbox"
                                                            checked={usuario.checked === "checked"}
                                                            onChange={() => togglePermissao(usuario.id)}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                    <div className="usuario-info">
                                                        <span className="usuario-nome">{usuario.nome}</span>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="no-results">Nenhum usuário encontrado</p>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button onClick={fecharModal} className="btn-cancelar">
                                Cancelar
                            </button>
                            <button 
                                onClick={salvarPermissoes} 
                                className="btn-salvar"
                                disabled={loading}
                            >
                                <FontAwesomeIcon icon={faSave} /> Salvar
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default ModalPermissoes;